import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cleanTrackName, timeout, playDelay } from '../../utils/utils';
import { selectTrack, setPlaylist } from '../../features/audioPlayer/audioPlayerSlice';
import { usePub } from '../../hooks/usePubSub';
import PlayButton from '../../assets/images/track_controls/play_ico_round.png';
import PauseButton from '../../assets/images/track_controls/pause_ico_round.png';
import './track-thumbnail.css';


const TrackThumbnail = ({track , playlist, artist, size}) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const publish = usePub();
	const trackIsPlaying = useSelector(state => state.audioPlayer.trackIsPlaying);
	const currentTrack = useSelector(state => state.audioPlayer.currentTrack);
	const [isHovered, setIsHovered] = useState(false);

	const handleClick = async (track) => {
		navigate(`/track/${track.id}`);
    };

    // TODO move this into utils
	const handlePlayPauseClick = async (event, track) => {
        event.stopPropagation();
		let changedSelection = false;
		// select the track if it is not the current track
		if (!currentTrack || (currentTrack && currentTrack.id !== track.id)) {
			changedSelection = true;
			dispatch(selectTrack(track));
			if (playlist) {
				dispatch(setPlaylist(playlist))
			}
		}
		// handle play/pause
		if (changedSelection) {
			await timeout(playDelay); // allow next audio source to load
            publish('audioPlayerEvent',{action:'play', track: track})
		} else {
			if (!trackIsPlaying) {
				publish('audioPlayerEvent',{action:'play', track: track})
			} else {
				publish('audioPlayerEvent',{action:'pause', track: track})
			}
		}
    };

	return (
		<div className='track-thumbnail-container'
			onClick={() => handleClick(track)}
			onMouseEnter={() => setIsHovered(true)} 
			onMouseLeave={() => setIsHovered(false)}
		>
			<div className='image-block' style={{ backgroundImage: `url(https://media.tracktribe.com/images/track_images/${track.image})`}}>
				{currentTrack && currentTrack.id === track.id && (
					<img 
						className='track-thumbnail-play-button' 
						src={ trackIsPlaying ? PauseButton : PlayButton } 
						alt='' 
						onClick={(event) => handlePlayPauseClick(event, track)}
					/>
				)}
				{isHovered && (!currentTrack || currentTrack.id !== track.id)  && (
					<img 
						className='track-thumbnail-play-button' 
						src={ PlayButton } 
						alt='' 
						onClick={(event) => handlePlayPauseClick(event, track)}
					/>
				)}
			</div>
			<div className='track-thumbnail-title'>{cleanTrackName(track.title)}</div>
			<div className='track-item'>{artist.artist_name}</div>
			
		</div>
	)
}

export default TrackThumbnail;